import { render, staticRenderFns } from "./TravelList.vue?vue&type=template&id=d4bdf1b2&"
import script from "./TravelList.vue?vue&type=script&lang=js&"
export * from "./TravelList.vue?vue&type=script&lang=js&"
import style0 from "./TravelList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports